import { fetchBaseQuery, retry } from "@reduxjs/toolkit/dist/query";
import { AppConfigs } from "config/appConfigs";
import { businessGroupDetails } from "consts/globals";
import { RootState } from "store";
import { AuthClientProvider } from "./client";

export function azureDevOpsBaseQuery() {
  return fetchBaseQuery({
    baseUrl: AppConfigs().azureDevOpsServiceBaseUrl,
    prepareHeaders: async (headers: Headers, { getState }) => {
      const authClient = AuthClientProvider.getInstance(); 
      const authenticationToken = await authClient.getAzureDevOpsToken();
       
       if (AppConfigs().businessUnitFeatureFlagging === true) {
              const { businessUnit } = getState() as RootState;
              const usrBusinessGroup = businessGroupDetails.find(
                (b) => b.tenant === businessUnit
              )?.businessGroup;
      
              headers.set("Tenant", `${usrBusinessGroup}`);
            }
      
      headers.set("authorization", `bearer ${authenticationToken}`);
      return headers;
    },
  });
}

export const azureDevOpsBaseQueryWithRetry = retry(azureDevOpsBaseQuery());
